export default "__VITE_ASSET__DgFfpx7L__"